import { PopoverPlacement } from "@idui/react-popover";
import { EmailOutlined as EmailIcon } from "@mui/icons-material";
import { FC, useMemo } from "react";
import { useTranslation } from "react-i18next";

import { FIELD_TYPE_IDS } from "@ryde/shared";
import { rydeColors } from "@ryde/theme";

import { FramerTooltip } from "../../common";
import { useDecorateWithMark } from "../../utils";
import { IRenderColumnTemplate } from "./_core";

export const EmailCellTemplate: FC<IRenderColumnTemplate> = ({
  id,
  value,
  name,
  formFieldTypeId,
  formAttributes,
  e2eData,
}) => {
  const { decorateValue } = useDecorateWithMark();

  const resolvedValue =
    formFieldTypeId === FIELD_TYPE_IDS.FORM.dropdown &&
    formAttributes?.selectItems?.length
      ? formAttributes.selectItems.find(i => i.value === value)?.label
      : value;

  const { t } = useTranslation();
  const emailMessage = t("general.EMAIL_SEND");

  const displayValue = useMemo(() => {
    return decorateValue(String(resolvedValue || ""));
  }, [resolvedValue, decorateValue]);

  const emailClickHandler = (): void => {
    if (!resolvedValue) {
      return;
    }

    window.location.href = `mailto:${resolvedValue}`;
  };

  return (
    <div
      className="cell_simple"
      data-e2e-custom={e2eData}
      data-e2e-id={`${name}_fieldid_${formFieldTypeId}`}
      data-e2e-value={resolvedValue}
      data-e2e-template="email-cell"
      data-e2e-custom-field-id={id}
    >
      <FramerTooltip
        content={`${emailMessage} ${resolvedValue}`}
        placement={PopoverPlacement.bottom}
      >
        {resolvedValue && (
          <EmailIcon
            style={{
              fontSize: "14px",
              transform: "translateY(20%)",
              marginInline: "2px",
              color: `${rydeColors.steel}`,
              cursor: "pointer",
              marginInlineEnd: "7px",
            }}
            onClick={emailClickHandler}
          />
        )}
      </FramerTooltip>

      <div
        className="cell_simple"
        data-e2e-id={`${name}_fieldid_${formFieldTypeId}`}
        data-e2e-value={resolvedValue}
        data-e2e-template="email-cell"
        data-e2e-custom-field-id={id}
      >
        <FramerTooltip
          content={resolvedValue}
          placement={PopoverPlacement.bottom}
        >
          <span>{displayValue}</span>
        </FramerTooltip>
      </div>
    </div>
  );
};
